import React, {useEffect, useState} from "react";
import * as prosConnect from "./ProsConnect";
import {
    addEnums,
    ATTR_TEXT,
    ATTR_ENUM_MAY_ADD,
    ATTR_ENUM_VALUES,
    prosLog,
    UI_LISTED_ELEMENTS_LIMIT
} from "./ProsConnect";
import {prosMultiFilterText, showMandatoryAndMissingMessage} from "./ProsCommonUi";
import BasicButton from "../components/BasicButton";
import TextButton from "../components/TextButton";
import Spacer from "../components/Spacer";
import LoadingAnimation from "../components/LoadingAnimation";
import TextInput from "../components/TextInput";
import {prosAppNotifNotice, prosAppNotifWarn} from "./ProsAppNotif";
import {setHelpContext} from "./HelpManager";

export default function ProsEnumMenu(props) {
    const [loading, setLoading] = useState(true)
    const [valuesFromServer, setValuesFromServer] = useState([])
    const [selectedValues, setSelectedValues] = useState([])
    const [filter, setFilter] = useState("")
    const [descriptionText, setDescriptionText] = useState("")
    const [mayAdd, setMayAdd] = useState("")

    const isEmailSelection = props.textFieldType.startsWith("email")
    let isEnumSelection = props.textFieldType.startsWith("enum")
    let mayChooseMultiple = props.textFieldType.startsWith("emails") || props.textFieldType.startsWith("enums")
    let dialogTitle
    let enumId = "email"
    let selType = "osoitetta"
    if (isEmailSelection && mayChooseMultiple) {
        dialogTitle = "Valitse sähköpostiosoitteet"
    } else if (isEmailSelection && !mayChooseMultiple) {
        dialogTitle = "Valitse sähköpostiosoite"
    } else if (isEnumSelection && mayChooseMultiple) {
        dialogTitle = "Valitse vaihtoehdot"
        selType = "valintaa"
        enumId = props.textFieldType.split("-")[1]
    } else {
        dialogTitle = "Valitse yksi vaihtoehto"
        selType = "valintaa"
        enumId = props.textFieldType.split("-")[1]
    }

    async function getEnumValuesFromServer() {
        prosLog('Getting emails')
        let enumInfo = await prosConnect.getEnumValues(enumId)
        let values = []
        if (enumInfo) {
            values = enumInfo[ATTR_ENUM_VALUES]
            setValuesFromServer(values)
            if (enumInfo[ATTR_TEXT]) {
                setDescriptionText(enumInfo[ATTR_TEXT])
            }
            if (enumInfo[ATTR_ENUM_MAY_ADD]) {
                setMayAdd(enumInfo[ATTR_ENUM_MAY_ADD])
            }
            // todo Sampo - should we show for user enum.text and/or id enum.obj_id ?
        }
        if(!props.txt){
            setLoading(false)
            return null
        }
        let initiallySelected = props.txt.split(";").filter(em => values.indexOf(em) >= 0)
        setSelectedValues(initiallySelected)
        setLoading(false)
    }

    useEffect(() => {
        getEnumValuesFromServer()
        setHelpContext('enumListSelecting')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props])

    const addFilterAsEnum = async (val) => {
        setLoading(true)
        let filteredTxt = prosConnect.replaceAll(val, ",", ";")
        let countAdded = await addEnums(enumId, filteredTxt)
        if (countAdded) {
            prosAppNotifNotice("Lisätty " + countAdded + " valintaa")
        } else {
            prosAppNotifWarn("Valinnan lisääminen epäonnistui")
        }
        await getEnumValuesFromServer()
    }

    const renderTextFilter = (showFilter) => {
        let isAllowedToAdd = ((mayAdd === "editor") && prosConnect.hasPermissionTo("addContent")) ||
            ((mayAdd === "mgr")    && prosConnect.hasPermissionTo("editAdmin"))
        let addValueButton = (isEmailSelection || !isAllowedToAdd) ? null :
            <>
                <TextButton
                    label={"Lisää uusi valinta"}
                    icon={"plus"}
                    onSubmit={(val) => addFilterAsEnum(val)}
                />
                <Spacer line />
            </>

        return <>
            {addValueButton}
            {showFilter ? <TextInput
                label={"Suodata listaa"}
                type={isEmailSelection ? "email" : "text"}
                value={filter}
                onChange={val => setFilter(val)}
            /> : null}
        </>
    }

    const onValueSelected = (value, isAdd) => {
        let newValue = []
        if (isAdd) {
            if (mayChooseMultiple) {
                newValue = selectedValues.concat([value])
            } else {
                newValue = [value]
            }
        } else {
            newValue = selectedValues.filter(em => em !== value)
        }
        setSelectedValues(newValue)
        if(typeof props.onChange === 'function') props.onChange(newValue.join(";"))
    }

    const renderValues = (title, isSourceList) => {
        let values = isSourceList ?
            valuesFromServer.filter(value => prosMultiFilterText(filter, value)) :
            selectedValues
        const valueList = values.map((value) =>{
            return <BasicButton
                key= {value + '__' + isSourceList}
                btnClass={""}
                label={value}
                selected={isSourceList && selectedValues.includes(value)}
                action={() => {
                    onValueSelected(value, isSourceList && !selectedValues.includes(value))
                }}
                icon={isSourceList ? "plus" : "minus"}
                iconSize={"sm"}
            />
        })
        return <div>
            <h3>{title}</h3>
            <div className={"tag-list"}>
                {values.length ? valueList : (isSourceList ? <p>Ei yhtään.</p> : <p>Ei valittuja.</p>)}
            </div>
        </div>
    }

    if(loading) return <LoadingAnimation />

    return <>
        <h3>{dialogTitle}</h3>
        <p>{descriptionText}</p>
        {showMandatoryAndMissingMessage(selectedValues.length < 1 && props.isMandatoryAndMissing)}
        <p>{valuesFromServer.filter(em => selectedValues.indexOf(em) < 0).length} {selType +  " käytettävissä"}.</p>
        {renderTextFilter(valuesFromServer.length > UI_LISTED_ELEMENTS_LIMIT)}
        <Spacer />
        <div className={"grid-container grid-1 grid-2_lg"}>
            {renderValues("Valitse", true)}
            {renderValues("Valittu", false)}
        </div>
    </>
}